import { useSeller, useUser } from 'src/contexts/userContext'
import { CounterByVertical } from 'src/types'

import { useCurrentVertical } from './useVerticals'

export interface UseUserCountsResult {
  futureOrdersToPrepareByVerticalCount?: number
  pendingClaimsByVerticalCount?: number
  todayOrdersToPrepareByVerticalCount?: number
  totalPendingClaimsCount?: number
  totalTodayOrdersToPrepareCount?: number
  totalUnsyncOrdersCount?: number
  unmappedPurchasedProductsCount?: number
  unreadChatMessagesCount?: number
  unsyncOrdersByVerticalCount?: number
  waitingInvoicesCount?: number
}

interface GetCountByVerticalArgs {
  counters?: CounterByVertical[]
  verticalId?: Id
}

export const getCountByVertical = ({ counters, verticalId }: GetCountByVerticalArgs) =>
  counters?.find(counter => counter.verticalId === verticalId)?.count

export const getTotalCount = (counters?: CounterByVertical[]) =>
  counters?.reduce((acc, { count }) => acc + count, 0)

export const useUserCounts = (): UseUserCountsResult => {
  const user = useUser()
  const seller = useSeller()
  const vertical = useCurrentVertical()

  const todayOrdersToPrepareByVerticalCount = getCountByVertical({
    counters: seller?.todayOrdersToPrepareByVertical,
    verticalId: vertical?.id,
  })
  const futureOrdersToPrepareByVerticalCount = getCountByVertical({
    counters: seller?.futureOrdersToPrepareByVertical,
    verticalId: vertical?.id,
  })
  const pendingClaimsByVerticalCount = getCountByVertical({
    counters: seller?.pendingClaimsCountByVertical,
    verticalId: vertical?.id,
  })
  const unsyncOrdersByVerticalCount = getCountByVertical({
    counters: seller?.unsyncOrderCountByVertical,
    verticalId: vertical?.id,
  })
  const totalUnsyncOrdersCount = getTotalCount(seller?.unsyncOrderCountByVertical)
  const totalTodayOrdersToPrepareCount = getTotalCount(seller?.todayOrdersToPrepareByVertical)
  const totalPendingClaimsCount = getTotalCount(seller?.pendingClaimsCountByVertical)

  return {
    futureOrdersToPrepareByVerticalCount,
    pendingClaimsByVerticalCount,
    todayOrdersToPrepareByVerticalCount,
    totalPendingClaimsCount,
    totalTodayOrdersToPrepareCount,
    totalUnsyncOrdersCount,
    unmappedPurchasedProductsCount: user?.nbPurchaseUnmapped,
    unsyncOrdersByVerticalCount,
    waitingInvoicesCount: seller?.waitingInvoices.total,
  }
}
